var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "referral_purchase-edit",
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticStyle: { width: "70%" },
          attrs: { model: _vm.form, "label-width": "120px" },
        },
        [
          _c(
            "el-form-item",
            [
              _c("el-alert", {
                attrs: {
                  title: "* 如果推荐商品在门店下被沽清，则推荐列表不显示",
                  size: "mini",
                  type: "error",
                  effect: "dark",
                  closable: false,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "活动名称：", prop: "activityName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入活动名称" },
                model: {
                  value: _vm.form.activityName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "activityName", $$v)
                  },
                  expression: "form.activityName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "点餐类型：", prop: "menuType" } },
            [
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.form.menuTypes,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "menuTypes", $$v)
                    },
                    expression: "form.menuTypes",
                  },
                },
                _vm._l(_vm.menuTypeList, function (item) {
                  return _c(
                    "el-checkbox",
                    { key: item.code, attrs: { label: item.code } },
                    [_vm._v("\n          " + _vm._s(item.desc) + "\n        ")]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "执行周期：", prop: "executeCycle" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.executeCycle,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "executeCycle", $$v)
                    },
                    expression: "form.executeCycle",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "weekly" } }, [
                    _vm._v("\n          按周执行\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: "range_date" } }, [
                    _vm._v("\n          按日期执行\n        "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "活动时间范围：" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "daterange",
                  format: "yyyy-MM-dd",
                  "value-format": "yyyy-MM-dd",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                },
                model: {
                  value: _vm.form.executeDateList,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "executeDateList", $$v)
                  },
                  expression: "form.executeDateList",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.executeCycle === "weekly"
            ? _c(
                "el-form-item",
                { attrs: { label: "执行星期：" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.form.daysOfWeekList,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "daysOfWeekList", $$v)
                        },
                        expression: "form.daysOfWeekList",
                      },
                    },
                    _vm._l(7, function (item) {
                      return _c(
                        "el-checkbox",
                        { key: item, attrs: { label: item } },
                        [_vm._v("\n          " + _vm._s(item) + "\n        ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "执行时间", prop: "executeTimeList" } },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("el-time-picker", {
                    attrs: {
                      "is-range": "",
                      format: "HH:mm",
                      "value-format": "HH:mm",
                      "range-separator": "至",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      placeholder: "选择时间范围",
                    },
                    model: {
                      value: _vm.form.executeTimeList,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "executeTimeList", $$v)
                      },
                      expression: "form.executeTimeList",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "关联商品：", prop: "relatedGoodsIdList" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "70%" },
                  attrs: {
                    filterable: "",
                    remote: "",
                    "reserve-keyword": "",
                    placeholder: "请搜索选项关联商品",
                    "remote-method": _vm.searchGoods,
                    loading: _vm.searchGoodsLoading,
                    "value-key": "goodsFnId",
                  },
                  model: {
                    value: _vm.referralGoods,
                    callback: function ($$v) {
                      _vm.referralGoods = $$v
                    },
                    expression: "referralGoods",
                  },
                },
                _vm._l(_vm.relatedGoodsList, function (item) {
                  return _c(
                    "el-option",
                    {
                      key: item.goodsFnId,
                      attrs: { label: item.goodsName, value: item },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c("span", [_vm._v(_vm._s(item.goodsName))]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(item.goodsCode))]),
                        ]
                      ),
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "text" },
                  on: { click: _vm.addReferralGoods },
                },
                [_vm._v("\n        添加\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  key: _vm.referralGoodsTableKey,
                  staticStyle: { width: "70%" },
                  attrs: {
                    border: "",
                    data: _vm.form.checkedReferralGoodsList,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "goodsCode", label: "商品编号" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "goodsName", label: "商品名称" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeReferraltGoods(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              移除\n            ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "推荐商品：", prop: "checkedSuggestGoodsList" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "70%" },
                  attrs: {
                    filterable: "",
                    remote: "",
                    "reserve-keyword": "",
                    placeholder: "请搜索选项推荐商品",
                    "remote-method": _vm.searchSuggestGoods,
                    loading: _vm.searchSuggestGoodsLoading,
                    "value-key": "fnId",
                  },
                  model: {
                    value: _vm.suggestGoods,
                    callback: function ($$v) {
                      _vm.suggestGoods = $$v
                    },
                    expression: "suggestGoods",
                  },
                },
                _vm._l(_vm.suggestGoodsList, function (item) {
                  return _c(
                    "el-option",
                    {
                      key: item.fnId,
                      attrs: { label: item.goodsName, value: item },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(item.goodsName) +
                                "(" +
                                _vm._s(item.unitName) +
                                ")"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticStyle: { color: "#999" } }, [
                            _vm._v("¥" + _vm._s(item.goodsPrice)),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { "font-size": "12px", color: "#999" } },
                        [_vm._v(_vm._s(item.goodsCode))]
                      ),
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "text" }, on: { click: _vm.addSuggestGoods } },
                [_vm._v("\n        添加\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  key: _vm.goodsTableKey,
                  staticStyle: { width: "70%" },
                  attrs: { border: "", data: _vm.form.checkedSuggestGoodsList },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "goodsCode", label: "商品编号" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "goodsName", label: "商品名称" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "unitName", label: "商品规格" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "activityPrice",
                      label: "活动价格 (￥)",
                      width: "160",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input-number", {
                              attrs: {
                                min: 0,
                                precision: 2,
                                step: 0.01,
                                size: "small",
                                "controls-position": "right",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleSuggestGoodsPriceChange(
                                    scope.row
                                  )
                                },
                              },
                              model: {
                                value: scope.row.activityPrice,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "activityPrice", $$v)
                                },
                                expression: "scope.row.activityPrice",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "sorts", label: "商品排序", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input-number", {
                              attrs: { min: 0, precision: 0, size: "small" },
                              model: {
                                value: scope.row.sorts,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "sorts", $$v)
                                },
                                expression: "scope.row.sorts",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeSuggestGoods(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n              移除\n            ")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "是否启用：", prop: "markForEnable" } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.form.markForEnable,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "markForEnable", $$v)
                    },
                    expression: "form.markForEnable",
                  },
                },
                [
                  _c("el-radio-button", { attrs: { label: false } }, [
                    _vm._v("\n          无效\n        "),
                  ]),
                  _vm._v(" "),
                  _c("el-radio-button", { attrs: { label: true } }, [
                    _vm._v("\n          有效\n        "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "全部门店：", prop: "storeScope" } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { "true-label": 0, "false-label": 1 },
                  on: { change: _vm.handleStoreScopeChange },
                  model: {
                    value: _vm.form.storeScope,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "storeScope", $$v)
                    },
                    expression: "form.storeScope",
                  },
                },
                [_vm._v("\n        全部门店\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.storeScope === 1
            ? _c(
                "el-form-item",
                { attrs: { label: "指定门店", prop: "relatedStoreIdList" } },
                _vm._l(_vm.regionStoreList, function (regionStore) {
                  return _c("region-store-pane", {
                    key: regionStore.regionId,
                    ref: "regionStorePane_" + regionStore.regionId,
                    refInFor: true,
                    attrs: {
                      "region-store": regionStore,
                      "echo-store-ids": _vm.form.relatedStoreIdList,
                    },
                    on: { change: _vm.handleRegionStoreChange },
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
                [_vm._v("\n        提交\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }